import React from 'react';
import { connect } from 'react-redux';
import { Link, Text } from '@beef/ui-kit';
import { compose } from '@beef/utils';
import { Flex } from '@fttb/common/components';
import { getNewsLink, getNewsSubTitle, getNewsTitle } from "../../../../store/blocks/news/selectors";
var _CarouselLayout = function _CarouselLayout(_ref) {
  var children = _ref.children,
    className = _ref.className,
    subTitle = _ref.subTitle,
    subTitleLink = _ref.subTitleLink,
    title = _ref.title;
  return /*#__PURE__*/React.createElement("section", {
    className: className,
    "data-t-id": "components-CarouselLayout"
  }, /*#__PURE__*/React.createElement(Flex, {
    alignItems: "end",
    className: "mar-b-m",
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "size2-m",
    tagType: "h2",
    "data-t-id": "components-CarouselLayout"
  }, title), /*#__PURE__*/React.createElement(Link, {
    href: subTitleLink,
    isNoUnderline: true,
    size: "size4-m"
  }, subTitle)), children);
};
var mapStateToProps = function mapStateToProps(state) {
  return {
    subTitle: getNewsSubTitle(state),
    subTitleLink: getNewsLink(state),
    title: getNewsTitle(state)
  };
};
var connector = connect(mapStateToProps);
export var CarouselLayout = compose(connector)(_CarouselLayout);